import React from 'react'
import BalanceDisplay from './BalanceDisplay'
import AccountBalanceDisplay from './AccountBalaneDisplay'

interface Props {}

function Wallets(props: Props) {
    const {} = props

    return (
        <>
        <BalanceDisplay/>
        <AccountBalanceDisplay/>
        </>
    )
}

export default Wallets
